module.exports = fox._r("images/thanksgiving/gift-156.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/thanksgiving/gift-156.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/thanksgiving/gift-156.png
// module id = 380
// module chunks = 4